"use client";

import { createContext, use } from "react";

import { isNil } from "@/common/helpers/lang";

export function createSafeContext<ContextValue>(errorMessage: string) {
  const Context = createContext<ContextValue | null>(null);

  const useSafeContext = () => {
    const context = use(Context);

    if (isNil(context)) {
      throw new Error(errorMessage);
    }

    return context;
  };

  return [Context, useSafeContext] as const;
}
